<div class="login-wrapper">
  <div class="ui container fluid">
    <div class="ui vertically padded grid">
      <div
        class="sixteen-wide-mobile sixteen-wide-tablet eight-wide-computer column blur-bg"
      >
        <div class="ui centered middle aligned grid">
          <div
            class="sixteen-wide-mobile sixteen-wide-mobile eleven-wide-computer column plr-2"
          >
            <img
              class="ui small left image"
              src="assets/images/signgaze-logo.svg"
            />
            <ng-container [ngSwitch]="currentView">
              <ng-container *ngSwitchCase="loginViewEnum.LOGIN">
                <signgaze-login></signgaze-login>
              </ng-container>
              <ng-container *ngSwitchCase="loginViewEnum.REGISTRATION">
                <signgaze-registration></signgaze-registration>
              </ng-container>
              <ng-container *ngSwitchCase="loginViewEnum.FORGOT_PASSWORD">
                <signgaze-forgot-password></signgaze-forgot-password>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div
        class="eight-wide-computer column pure-hidden-xs pure-hidden-sm pure-hidden-md"
      >
        <div class="ui top right aligned segment">
          <ng-container [ngSwitch]="currentView">
            <ng-container *ngSwitchCase="loginViewEnum.LOGIN">
              <button
                class="ui large secondary black button circular"
                (click)="changeLoginView(loginViewEnum.REGISTRATION)"
              >
                Register
              </button>
            </ng-container>
            <ng-container *ngSwitchCase="loginViewEnum.REGISTRATION">
              <button
                class="ui large secondary black button circular"
                (click)="changeLoginView(loginViewEnum.LOGIN)"
              >
                Login
              </button>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
